import { useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";
export default function CashbackLoading({ failed = false, requiresProfile = false, onRetry, children }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    setSlow(false);
    if (failed || requiresProfile) return;
    const timer = setTimeout(() => setSlow(true), 12000);
    return () => clearTimeout(timer);
  }, [failed, requiresProfile]);
  return <section className="mx-auto flex min-h-[50vh] max-w-xl flex-col items-center justify-center px-4 text-center text-white" aria-busy={!failed && !requiresProfile}>
    {!failed && !requiresProfile && <LoaderCircle aria-hidden="true" className="mb-5 h-10 w-10 cashback-accent-text motion-safe:animate-spin" />}
    <h1 className="font-nunito text-2xl font-bold">{requiresProfile ? "Complete seu cadastro" : failed ? "Não foi possível carregar todos os benefícios" : "Preparando seu Cashback"}</h1>
    <p role={failed ? "alert" : "status"} className="mt-3 text-zinc-300">{requiresProfile ? "Precisamos do seu CPF para conectar sua conta de benefícios." : failed ? "Algumas informações não chegaram. Tente novamente em instantes." : "Estamos conectando sua conta e carregando saldos, marcas e benefícios…"}</p>
    {failed && onRetry && <button type="button" onClick={onRetry} className="mt-5 rounded-xl cashback-primary-button px-5 py-3 font-bold">Tentar novamente</button>}
    {slow && !failed && <p className="mt-3 text-sm text-zinc-400">A conexão está levando um pouco mais de tempo. Você pode continuar aguardando.</p>}
    {(failed || requiresProfile || slow) && children}
  </section>;
}
